import { fork } from 'redux-saga/effects';
import google from './google';

export default function* logging() {
  yield fork(google);
}
